import { defineMessages } from 'react-intl'

const scope = `procurify.modules.purchasing.pages.CustomizeOrderFormPage`

export default defineMessages({
  settingsTitle: {
    id: `${scope}.settingsTitle`,
    defaultMessage: 'Settings',
  },
  customizeOrderFormTitle: {
    id: `${scope}.customizeOrderFormTitle`,
    defaultMessage: 'Customize request for order form',
  },
  moduleLoading: {
    id: `${scope}.moduleLoading`,
    defaultMessage: 'Module loading...',
  },
})
